import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntdApp, ConfigProvider } from "antd";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DEFAULT_PRIMARY_COLOR, ReducedMotionProvider, SECONDARY_COLOR, SECONDARY_FOREGROUND } from "@tripbox/ui";
import App from "./App.tsx";
import { AppErrorBoundary } from "./components/ErrorFallback";
import { installActionTrail } from "./lib/actionTrail";
import "./index.css";
import { registerServiceWorker } from "./pwa";

installActionTrail();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        token: {
          colorPrimary: SECONDARY_COLOR,
          colorInfo: DEFAULT_PRIMARY_COLOR,
          colorLink: DEFAULT_PRIMARY_COLOR,
          colorTextLightSolid: SECONDARY_FOREGROUND,
          fontFamily: "Noto Sans, sans-serif",
        },
        components: {
          InputNumber: {
            controlWidth: 120,
          },
        },
      }}
    >
      <ReducedMotionProvider>
        <AntdApp>
          <QueryClientProvider client={queryClient}>
            <AppErrorBoundary>
              <App />
            </AppErrorBoundary>
          </QueryClientProvider>
        </AntdApp>
      </ReducedMotionProvider>
    </ConfigProvider>
  </StrictMode>
);

registerServiceWorker();
